// Mock data for Wholesome 360 redesign
// All pricing, descriptions, calories sourced directly from wholesome360.com

export const NAV_LINKS = [
  { label: 'Menu', href: '#menu' },
  { label: 'How it works', href: '#how' },
  { label: 'Catering Menu', href: '#catering' },
  { label: 'Fridge Program', href: '#fridge' },
  { label: 'About', href: '#about' },
];

export const LOGO_URL = '/images/logo.png';

export const MENU_CATEGORIES = [
  { id: 'bowls', label: 'Bowls' },
  { id: 'salads', label: 'Salads' },
  { id: 'wraps', label: 'Wraps' },
  { id: 'desserts', label: 'Desserts' },
  { id: 'beverages', label: 'Beverages' },
];

// Photography from wholesome360.com
export const IMG = {
  kale: '/images/kale.jpg',
  figFeta: '/images/fig-feta.jpg',
  powerBowl: '/images/power-bowl.jpg',
  greenPower: '/images/green-power.jpg',
  roastedVeg: '/images/roasted-veg.jpg',
  cultural: '/images/cultural.jpg',
  spread: '/images/spread.jpg',
  about: '/images/about.jpg',
};

// Build-your-own bowl customization — shared modifier templates keep the ordering
// experience consistent across bowls.
const STANDARD_PROTEIN = [
  { name: 'Chicken', included: true },
  { name: 'Skirt Steak', price: 3 },
  { name: 'Seitan', price: 3 },
];
const STANDARD_EXTRA_PROTEIN = [
  { name: 'Chicken', price: 2 },
  { name: 'Steak', price: 4 },
  { name: 'Seitan', price: 4 },
];
const STANDARD_PACKAGING = [
  { name: 'Individual packaging' },
  { name: 'Tray packaging' },
];

const bowlProteinGroups = () => [
  { id: 'protein', name: 'Protein', min: 1, max: 1, options: STANDARD_PROTEIN },
  { id: 'extra-protein', name: 'Extra Protein', min: 0, max: 3, options: STANDARD_EXTRA_PROTEIN },
];
const bowlPackagingGroup = () => ({
  id: 'packaging', name: 'Packaging', min: 1, max: 1, options: STANDARD_PACKAGING,
});

export const BOWL_BUILDERS = {
  'byo-power': {
    title: 'Build Your Own Power Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Fluffy Couscous' },
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 5, options: [
        { name: 'Zucchini' },
        { name: 'Sautéed Carrots' },
        { name: 'Peppers' },
        { name: 'Corn' },
        { name: 'Chickpeas' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Harissa hot sauce' },
        { name: 'Mint yogurt' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'byo-veg': {
    title: 'Build Your Own Roasted Veggie Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Couscous' },
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 4, options: [
        { name: 'Sautéed Cauliflower' },
        { name: 'Grilled Brussels Sprouts' },
        { name: 'Sautéed Broccoli' },
        { name: 'Roasted Peppers' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Harissa' },
        { name: 'Avocado lime' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'byo-green': {
    title: 'Build Your Own Green Power Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Organic Quinoa' },
        { name: 'Couscous' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 4, options: [
        { name: 'Sautéed Bell Peppers' },
        { name: 'Kale' },
        { name: 'Cauliflower' },
        { name: 'Grilled Italian Zucchini' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Avocado lime' },
        { name: 'Harissa' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'byo-lemon-herb': {
    title: 'Build Your Own Lemon Herb Chicken Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Farro' },
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables & Toppings', min: 0, max: 7, options: [
        { name: 'Cucumber' },
        { name: 'Cherry Tomatoes' },
        { name: 'Red Onion' },
        { name: 'Arugula' },
        { name: 'Kalamata Olives' },
        { name: 'Feta' },
        { name: 'Fresh Dill' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Lemon dill yogurt sauce' },
        { name: 'Olive oil dressing' },
      ]},
      { id: 'protein', name: 'Protein', min: 1, max: 1, options: [
        { name: 'Lemon Oregano Chicken', included: true },
      ]},
      { id: 'extra-protein', name: 'Extra Chicken', min: 0, max: 3, options: [
        { name: 'Chicken', price: 2 },
      ]},
      bowlPackagingGroup(),
    ],
  },
  'byo-moroccan': {
    title: 'Build Your Own Moroccan Sunshine Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Couscous' },
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 4, options: [
        { name: 'Crispy Chickpeas' },
        { name: 'Sautéed Cauliflower' },
        { name: 'Carrots' },
        { name: 'Kale' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Lemon Mint Yogurt' },
        { name: 'Harissa' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'byo-buddha': {
    title: 'Build Your Own Buddha Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 5, options: [
        { name: 'Chickpeas' },
        { name: 'Cucumber' },
        { name: 'Roasted Cauliflower' },
        { name: 'Beets' },
        { name: 'Sautéed Kale' },
      ]},
      { id: 'nuts', name: 'Nuts', min: 0, max: 1, options: [
        { name: 'Walnuts' },
        { name: 'Pecans' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Harissa' },
        { name: 'Avocado lime' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'byo-harvest': {
    title: 'Build Your Own Harvest Bowls',
    groups: [
      { id: 'grain', name: 'Grain', min: 1, max: 1, options: [
        { name: 'Couscous' },
        { name: 'Quinoa' },
      ]},
      { id: 'vegetables', name: 'Vegetables', min: 0, max: 4, options: [
        { name: 'Grilled Brussels Sprouts' },
        { name: 'Sautéed Zucchini' },
        { name: 'Sautéed Cabbage' },
        { name: 'Roasted Chickpeas' },
      ]},
      { id: 'sauce', name: 'Sauce', min: 1, max: 1, options: [
        { name: 'Harissa' },
        { name: 'Yogurt za’atar & lime' },
      ]},
      ...bowlProteinGroups(),
      bowlPackagingGroup(),
    ],
  },
  'greek-wrap': {
    title: 'Greek Wrap',
    groups: [
      { id: 'wrap', name: 'Choose Your Wrap', min: 1, max: 1, options: [
        { name: 'Spinach-Herb Wrap' },
        { name: 'Sun-Dried Tomato Wrap' },
      ]},
      { id: 'packaging', name: 'Wrap Packaging', min: 1, max: 1, options: [
        { name: 'Individual' },
        { name: 'Tray' },
      ]},
    ],
  },
  'superfood-wrap': {
    title: 'Superfood Wrap',
    groups: [
      { id: 'wrap', name: 'Choose Your Wrap', min: 1, max: 1, options: [
        { name: 'Spinach-Herb Wrap' },
        { name: 'Sun-Dried Tomato Wrap' },
      ]},
      { id: 'packaging', name: 'Wrap Packaging', min: 1, max: 1, options: [
        { name: 'Individual' },
        { name: 'Tray' },
      ]},
    ],
  },
  'skirt-steak-wrap': {
    title: 'Skirt Steak Wrap',
    groups: [
      { id: 'wrap', name: 'Choose Your Wrap', min: 1, max: 1, options: [
        { name: 'Spinach-Herb Wrap' },
        { name: 'Sun-Dried Tomato Wrap' },
      ]},
      { id: 'packaging', name: 'Wrap Packaging', min: 1, max: 1, options: [
        { name: 'Individual' },
        { name: 'Tray' },
      ]},
    ],
  },
};

// Menu items — bowls, salads, wraps, breakfast, desserts, beverages
export const MENU_ITEMS = [
  // BOWLS
  {
    id: 'byo-power',
    category: 'bowls',
    name: 'Build Your Own Power Bowls',
    short: 'Power Bowls',
    description:
      'Fluffy couscous or quinoa topped with zucchini, sautéed carrots, peppers, corn and chickpeas. Sauces: harissa hot sauce or mint yogurt. Available individually or family style.',
    ingredients: [
      'Grain: Fluffy couscous or quinoa',
      'Vegetables: zucchini, sautéed carrots, peppers, corn, chickpeas',
      'Sauces: harissa hot sauce or mint yogurt',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
      'Packaging: individual or tray',
    ],
    price: 16.89,
    calories: '518–578',
    serves: '1 person',
    rating: 4.9,
    popular: true,
    tags: ['Customizable', 'High-protein', 'Mediterranean'],
    image: IMG.powerBowl,
  },
  {
    id: 'byo-veg',
    category: 'bowls',
    name: 'Build Your Own Roasted Veggie Bowls',
    short: 'Roasted Veggie Bowls',
    description:
      'Couscous or quinoa with sautéed cauliflower, grilled Brussels sprouts, sautéed broccoli and roasted peppers. Sauces: harissa or avocado lime.',
    ingredients: [
      'Grain: couscous or quinoa',
      'Vegetables: sautéed cauliflower, grilled Brussels sprouts, sautéed broccoli, roasted peppers',
      'Sauces: harissa or avocado lime',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
    ],
    price: 16.89,
    calories: '495–565',
    serves: '1 person',
    rating: 4.8,
    tags: ['Customizable', 'Plant-based', 'Vegan-option'],
    image: IMG.roastedVeg,
  },
  {
    id: 'byo-green',
    category: 'bowls',
    name: 'Build Your Own Green Power Bowls',
    short: 'Green Power Bowls',
    description:
      'Organic quinoa or couscous with sautéed bell peppers, kale, cauliflower and grilled Italian zucchini. Sauces: avocado lime or harissa.',
    ingredients: [
      'Grain: organic quinoa or couscous',
      'Vegetables: sautéed bell peppers, kale, cauliflower, grilled Italian zucchini',
      'Sauces: avocado lime or harissa',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
      'Packaging: individual or tray',
    ],
    price: 16.89,
    calories: '505–575',
    serves: '1 person',
    rating: 4.8,
    popular: true,
    tags: ['Customizable', 'Gluten-free', 'Mediterranean'],
    image: IMG.greenPower,
  },
  {
    id: 'byo-lemon-herb',
    category: 'bowls',
    name: 'Build Your Own Lemon Herb Chicken Bowls',
    short: 'Lemon Herb Chicken Bowls',
    description:
      'Farro or quinoa with cucumber, cherry tomatoes, red onion, arugula, kalamata olives, feta and fresh dill. Sauces: lemon dill yogurt sauce or olive oil dressing.',
    ingredients: [
      'Grain: farro or quinoa',
      'Vegetables & Toppings: cucumber, cherry tomatoes, red onion, arugula, kalamata olives, feta, fresh dill',
      'Sauces: lemon dill yogurt sauce or olive oil dressing',
      'Protein: lemon oregano chicken (included)',
      'Extra Chicken: +$2',
      'Packaging: individual or tray',
    ],
    price: 16.39,
    calories: '540–610',
    serves: '1 person',
    rating: 4.9,
    tags: ['Customizable', 'High-protein', 'Mediterranean'],
    image: '/images/lemon-herb-chicken.jpg',
  },
  {
    id: 'byo-moroccan',
    category: 'bowls',
    name: 'Build Your Own Moroccan Sunshine Bowls',
    short: 'Moroccan Sunshine Bowls',
    description:
      'Couscous or quinoa with crispy chickpeas, sautéed cauliflower, carrots and kale. Sauces: lemon mint yogurt or harissa.',
    ingredients: [
      'Grain: couscous or quinoa',
      'Vegetables: crispy chickpeas, sautéed cauliflower, carrots, kale',
      'Sauces: lemon mint yogurt or harissa',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
      'Packaging: individual or tray',
    ],
    price: 16.99,
    calories: '525–595',
    serves: '1 person',
    rating: 4.8,
    tags: ['Customizable', 'Mediterranean', 'Anti-inflammatory'],
    image: LOGO_URL,
  },
  {
    id: 'byo-buddha',
    category: 'bowls',
    name: 'Build Your Own Buddha Bowls',
    short: 'Buddha Bowls',
    description:
      'Chickpeas, quinoa, cucumber, roasted cauliflower, beets, walnuts or pecans and sautéed kale. Sauces: harissa or avocado lime.',
    ingredients: [
      'Grain: quinoa',
      'Vegetables: chickpeas, cucumber, roasted cauliflower, beets, sautéed kale',
      'Nuts: walnuts or pecans',
      'Sauces: harissa or avocado lime',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
    ],
    price: 16.99,
    calories: '480–560',
    serves: '1 person',
    rating: 4.9,
    tags: ['Customizable', 'Plant-based', 'Gluten-free'],
    image: '/images/buddha-bowl.jpg',
  },
  {
    id: 'byo-harvest',
    category: 'bowls',
    name: 'Build Your Own Harvest Bowls',
    short: 'Harvest Bowls',
    description:
      'Couscous or quinoa with grilled Brussels sprouts, sautéed zucchini, sautéed cabbage and roasted chickpeas. Sauces: harissa or yogurt za’atar & lime.',
    ingredients: [
      'Grain: couscous or quinoa',
      'Vegetables: grilled Brussels sprouts, sautéed zucchini, sautéed cabbage, roasted chickpeas',
      'Sauces: harissa or yogurt za’atar & lime',
      'Protein: chicken (included), skirt steak (+$3), seitan (+$3)',
      'Extra Protein: chicken (+$2), steak (+$4), seitan (+$4)',
      'Packaging: individual or tray',
    ],
    price: 15.99,
    calories: '510–580',
    serves: '1 person',
    rating: 4.8,
    tags: ['Customizable', 'Seasonal', 'Anti-inflammatory'],
    image: LOGO_URL,
  },

  // SALADS
  {
    id: 'kale-quinoa-steak',
    category: 'salads',
    name: 'Organic Kale & Quinoa Salad with Skirt Steak',
    short: 'Kale & Quinoa w/ Skirt Steak',
    description:
      'Skirt steak, organic kale with cucumbers, apples, organic quinoa, dried cranberries, grilled skirt steak and red wine vinaigrette.',
    ingredients: [
      'Grilled grass-fed skirt steak',
      'Organic kale',
      'Organic quinoa',
      'Cucumbers, apples, dried cranberries',
      'Red wine vinaigrette',
    ],
    price: 15.99,
    serves: '1 person',
    rating: 4.9,
    popular: true,
    tags: ['Gluten-free', 'High-protein'],
    image: IMG.kale,
  },
  {
    id: 'fig-feta',
    category: 'salads',
    name: 'Greek Fig and Feta Salad',
    short: 'Greek Fig & Feta',
    description:
      'Organic spring mix with sun-dried fig, feta, pecans, roasted sunflower seeds, roasted mini peppers and balsamic vinaigrette.',
    ingredients: [
      'Organic spring mix',
      'Sun-dried fig',
      'Feta cheese',
      'Pecans & sunflower seeds',
      'Roasted mini peppers',
      'Balsamic vinaigrette',
    ],
    price: 15.79,
    calories: '604',
    serves: '1 person',
    rating: 5.0,
    popular: true,
    tags: ['Vegetarian', 'Gluten-free'],
    image: IMG.figFeta,
  },
  {
    id: 'green-goddess',
    category: 'salads',
    name: 'Green Goddess Salad',
    short: 'Green Goddess',
    description:
      'Organic mixed greens with goat cheese, apples, cucumbers, dates and balsamic vinaigrette.',
    ingredients: [
      'Organic mixed greens',
      'Goat cheese',
      'Apples & cucumbers',
      'Medjool dates',
      'Balsamic vinaigrette',
    ],
    price: 15.99,
    calories: '547',
    serves: '1 person',
    rating: 4.7,
    tags: ['Vegetarian', 'Gluten-free'],
    image: '/images/green-goddess.jpg',
  },

  // WRAPS
  {
    id: 'greek-wrap',
    category: 'wraps',
    name: 'Greek Wrap',
    short: 'Greek Wrap',
    description:
      'Feta cheese, kalamata olives, cherry tomatoes, spinach and olive oil vinaigrette on your choice of wrap. Served with side salad.',
    ingredients: [
      'Feta cheese',
      'Kalamata olives',
      'Cherry tomatoes & spinach',
      'Olive oil vinaigrette',
      'Choice of wrap + side salad',
    ],
    price: 15.59,
    serves: '1 person',
    rating: 4.7,
    tags: ['Vegetarian'],
    image: '/images/greek-wrap.jpg',
  },
  {
    id: 'superfood-wrap',
    category: 'wraps',
    name: 'Superfood Wrap',
    short: 'Superfood Wrap',
    description:
      'Grilled chicken, sauteed Swiss chard (with onions & garlic), sauteed mushrooms and balsamic vinaigrette on your choice of wrap.',
    ingredients: [
      'Grilled chicken',
      'Sauteed Swiss chard (onions & garlic)',
      'Sauteed mushrooms',
      'Balsamic vinaigrette',
      'Choice of wrap',
    ],
    price: 15.99,
    serves: '1 person',
    rating: 4.9,
    tags: ['High-protein'],
    image: '/images/superfood-wrap.jpg',
  },
  {
    id: 'skirt-steak-wrap',
    category: 'wraps',
    name: 'Skirt Steak Wrap',
    short: 'Skirt Steak Wrap',
    description:
      'Grilled skirt steak, sautéed bell peppers, sautéed Swiss chard, grilled onions, and avocado lime sauce. Served with a side salad.',
    ingredients: [
      'Grilled skirt steak',
      'Sautéed bell peppers',
      'Sautéed Swiss chard',
      'Grilled onions',
      'Avocado lime sauce',
      'Side salad',
    ],
    price: 16.89,
    serves: '1 person',
    rating: 4.9,
    tags: ['High-protein', 'Gluten-free'],
    image: '/images/skirt-steak-wrap.jpg',
  },

  // DESSERTS
  {
    id: 'classic-brownie',
    category: 'desserts',
    name: 'Classic Brownie',
    short: 'Classic Brownie',
    description:
      'Our classic chocolate brownies, made with rich raw cacao for a deeply chocolatey flavor.',
    ingredients: [
      'Rich raw cacao',
      'Made from scratch',
    ],
    price: 139.0,
    serves: '1 tray — serves 20 people',
    rating: 4.9,
    tags: ['Crowd favorite'],
    image: '/images/classic-brownie.jpg',
  },
  {
    id: 'tiramisu',
    category: 'desserts',
    name: 'Tiramisu',
    short: 'Tiramisu',
    description:
      'House-made tiramisu featuring espresso-liqueur-soaked ladyfingers, sweet mascarpone cream, whipped cream, and a touch of agave. Egg-free.',
    ingredients: [
      'Espresso-liqueur-soaked ladyfingers',
      'Sweet mascarpone cream',
      'Whipped cream',
      'Touch of agave',
    ],
    price: 159.0,
    serves: '1 tray — serves 20 to 24 people',
    rating: 5,
    tags: ['Egg-free', 'House-made'],
    image: '/images/tiramisu.jpg',
  },
  {
    id: 'choc-mousse',
    category: 'desserts',
    name: 'Chocolate Mousse Parfait',
    short: 'Chocolate Mousse',
    description:
      'An indulgent but light mousse parfait made with high-quality, nutrition-packed ingredients including raw cacao.',
    ingredients: ['Raw cacao', 'Nutrition-packed base', 'Naturally sweetened'],
    price: 6.49,
    serves: '1 cup',
    rating: 4.8,
    tags: ['Vegetarian'],
    image: '/images/mousse-parfait.jpg',
  },

  // BEVERAGES
  {
    id: 'spindrift-lemon',
    category: 'beverages',
    name: 'Spindrift Lemon Sparkling Water',
    short: 'Spindrift Lemon',
    description:
      'Crisp and invigorating sparkling water made with real fruit. No artificial sweeteners.',
    ingredients: ['Sparkling water', 'Real lemon'],
    price: 3.49,
    serves: '1 can',
    rating: 4.7,
    tags: ['Sparkling'],
    image: '/images/bev-lemon.jpg',
  },
  {
    id: 'spindrift-limeade',
    category: 'beverages',
    name: 'Spindrift Lemon Limeade',
    short: 'Lemon Limeade',
    description:
      'Crisp Spindrift Lemon Limeade made with sparkling water and real fruit. No artificial sweeteners.',
    ingredients: ['Sparkling water', 'Lemon & lime'],
    price: 3.49,
    serves: '1 can',
    rating: 4.6,
    tags: ['Sparkling'],
    image: '/images/bev-limeade.jpg',
  },
  {
    id: 'spindrift-grapefruit',
    category: 'beverages',
    name: 'Spindrift Grapefruit',
    short: 'Grapefruit',
    description:
      'Zesty Spindrift Grapefruit sparkling water. All-natural with no added sweeteners or artificial flavors.',
    ingredients: ['Sparkling water', 'Real grapefruit'],
    price: 3.49,
    serves: '1 can',
    rating: 4.6,
    tags: ['Sparkling'],
    image: '/images/bev-grapefruit.jpg',
  },
  {
    id: 'spindrift-blood-orange',
    category: 'beverages',
    name: 'Spindrift Blood Orange Tangerine',
    short: 'Blood Orange Tangerine',
    description:
      'A vibrant blend of blood orange and tangerine. Crisp, tangy and free of artificial flavors.',
    ingredients: ['Sparkling water', 'Blood orange & tangerine'],
    price: 3.49,
    serves: '1 can',
    rating: 4.7,
    tags: ['Sparkling'],
    image: '/images/bev-blood-orange.jpg',
  },
];

export const HOW_IT_WORKS = [
  {
    step: '01',
    title: 'Tell us about your event',
    body: 'Date, headcount, delivery address and any dietary needs. Takes under a minute.',
  },
  {
    step: '02',
    title: 'Pick a chef-curated menu',
    body: 'Browse Mediterranean-inspired bowls, salads and trays built for office lunches.',
  },
  {
    step: '03',
    title: 'We deliver and set up — or you pick up free',
    body: 'Free delivery included on all catering orders, with full setup. Prefer pickup? That\'s free too.',
  },
];

export const STATS = [
  { value: '10+', label: 'Years serving Chicago' },
  { value: '5.0', label: '31 Google reviews' },
  { value: '20 mi', label: 'Delivery radius' },
  { value: 'Free', label: 'Delivery on all orders' },
];

export const FAQS = [
  {
    q: 'How far in advance do I need to order?',
    a: 'We require 24-hour notice on all catering orders so our chefs can prepare everything fresh that morning.',
  },
  {
    q: 'What is the minimum order?',
    a: 'Our minimum order is $300. Free delivery and complete setup are included on all catering orders, and tipping is optional at checkout.',
  },
  {
    q: 'Can all dishes be made gluten-free?',
    a: 'Yes — all catering dishes can be made gluten-free upon request. Note your preferences in the special instructions when ordering.',
  },
  {
    q: 'Where do you deliver?',
    a: 'We deliver anywhere within a 20-mile radius of West Town, Chicago (60612), 7 days a week. Prefer to grab it yourself? Free pickup is available at checkout.',
  },
  {
    q: 'What hours are you open?',
    a: 'Monday through Sunday, 9 AM – 6 PM.',
  },
  {
    q: 'What are the benefits of the Mediterranean diet?',
    a: 'The Mediterranean diet is consistently ranked among the healthiest ways to eat — rich in olive oil, vegetables, lean proteins and whole grains, it supports heart health, steady energy and reduced inflammation. Every Wholesome 360 dish is built on these anti-inflammatory foods, so your team eats well without thinking about it.',
  },
  {
    q: 'What are some healthy office lunch ideas?',
    a: 'Our most popular healthy office lunches are build-your-own Mediterranean bowls, chef-made salads like the Greek Fig & Feta or Organic Kale & Quinoa, and wrap platters. Mixing bowls, salads and wraps covers gluten-free, vegan and vegetarian teammates in one order.',
  },
  {
    q: 'Do you offer meal prep in Chicago?',
    a: 'Yes — beyond event catering, our office Fridge Program stocks your workplace with individually packaged, chef-prepared Mediterranean meals each week. It works like meal prep for your whole team, with zero ordering or cleanup.',
  },
];

export const INGREDIENT_PILLARS = [
  { title: 'Olive oil', body: 'Extra-virgin, cold-pressed. The base of every sauce we make.' },
  { title: 'Ghee', body: 'Slow-clarified butter that’s gentle on digestion and full of flavor.' },
  { title: 'Beef tallow', body: 'Grass-fed beef tallow for roasting and searing — rich, stable and never seed-oil-adjacent.' },
  { title: 'Never Fried', body: 'We roast, grill and sauté — nothing is deep-fried, ever.' },
  { title: 'Organic greens', body: 'Kale, spring mix and herbs delivered fresh each week.' },
];

// Fridge Program data
export const FRIDGE_PROGRAM = {
  tag: 'Office Fridge Program',
  headline: {
    before: 'A stocked fridge of ',
    emphasis: 'chef-made meals',
    after: ', delivered to your office.',
  },
  intro:
    'We provide the fridge, deliver the meals, keep it stocked and handle all the maintenance. Your team just opens the door and grabs a chef-crafted bowl, salad or wrap — no ordering, no coordination, no cleanup.',
  provisioning: {
    title: 'Everything included, end to end',
    lines: [
      'We provide the commercial-grade fridge at no extra cost.',
      'We restock it 2–3x per week with fresh, chef-made meals.',
      'We handle all cleaning, maintenance and menu rotation.',
      'You pay a single flat weekly rate — no surprise invoices.',
    ],
  },
  benefits: [
    { title: 'Fridge included', body: 'We install and maintain a commercial-grade fridge in your office at no additional cost.' },
    { title: 'We stock it for you', body: 'Fresh, chef-made meals delivered directly — you never place an order.' },
    { title: 'Full maintenance', body: 'Our team cleans, restocks and rotates the menu so your fridge always looks and works its best.' },
    { title: 'Cleaner than takeout', body: 'Every meal is anti-inflammatory and made with olive oil, ghee, butter & beef tallow only.' },
  ],
  tiers: [
    {
      name: 'Starter', size: '10–25', perWeek: '~50 meals',
      price: '$749', frequency: '/week',
      includes: ['2 restocks per week', '6 menu rotations', 'Free delivery + setup', 'Dedicated account manager'],
      featured: false,
    },
    {
      name: 'Team', size: '25–75', perWeek: '~120 meals',
      price: '$1,779', frequency: '/week',
      includes: ['3 restocks per week', 'Full menu access', 'Free delivery + setup', 'Custom dietary preferences', 'Monthly menu review'],
      featured: true,
    },
    {
      name: 'HQ', size: '75+', perWeek: 'Custom volume',
      price: 'Custom', frequency: 'quote',
      includes: ['Daily restocking', 'Multi-fridge support', 'On-site events included', 'Quarterly nutrition workshop'],
      featured: false,
    },
  ],
};

export const HERO_IMAGE = IMG.spread;
export const SECONDARY_IMAGE = IMG.cultural;
